import {
    GET_STAFF_START,
    GET_STAFF_SUCCESS,
    GET_STAFF_ERROR,
    ADD_STAFF_START,
    ADD_STAFF_SUCCESS,
    ADD_STAFF_ERROR,
    UPDATE_STAFF_START,
    UPDATE_STAFF_SUCCESS,
    UPDATE_STAFF_ERROR,
    DELETE_STAFF_START,
    DELETE_STAFF_SUCCESS,
    DELETE_STAFF_ERROR,
} from './staffTypes';

const initialState = {
    staff: [],
    loading: false,
    error: null,
    total: 0,
    page: 1,
    limit: 10,
};

const staffReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_STAFF_START:
        case ADD_STAFF_START:
        case UPDATE_STAFF_START:
        case DELETE_STAFF_START:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case GET_STAFF_SUCCESS:
            return {
                ...state,
                staff: action.payload.staff,
                total: action.payload.total,
                page: action.payload.page,
                limit: action.payload.limit,
                loading: false,
            };

        case ADD_STAFF_SUCCESS:
        case UPDATE_STAFF_SUCCESS:
        case DELETE_STAFF_SUCCESS:
            return {
                ...state,
                loading: false,
            };

        case GET_STAFF_ERROR:
        case ADD_STAFF_ERROR:
        case UPDATE_STAFF_ERROR:
        case DELETE_STAFF_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default staffReducer;
